import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormGroup } from '@angular/forms';
import { AgreementViewModel } from '../../model/view-model/agreement/agreement.view.model';
import { MessageModel, MessageType } from '../../model/message.model';

@Injectable({
  providedIn: 'root',
})
export class RegisterValidatorService {
  constructor(private translate: TranslateService) {}

  public handlePropertiesErrors(errorResponse: HttpErrorResponse) {
    const messages = {};
    const hasError = errorResponse.error && errorResponse.error.error && errorResponse.error.error.code;
    const errorCode = errorResponse.error.error.code;

    if (hasError) {
      switch (errorCode) {
        case 10001:
        case 10106:
          messages['firstName'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
        case 10002:
        case 10107:
          messages['lastName'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
        case 10003:
        case 10004:
        case 10005:
        case 10007:
        case 10102:
        case 20401:
          messages['email'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
        case 10008:
          messages['login'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
        case 10010:
          messages['phone'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
        case 486:
          messages['oldPassword'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
        case 10009:
        case 10006:
          messages['password'] = new MessageModel(MessageType.warning, this.translate.instant(`errors.${errorCode}`, errorCode));
          break;
      }
    }
    return messages;
  }

  public handleErrors(errorResponse: HttpErrorResponse) {
    const messages = [];
    const hasError = errorResponse.error && errorResponse.error.error && (errorResponse.error.error.code !== undefined || true);
    const errorCode = errorResponse.error.error.code;
    const errorMessage = errorResponse.error.error.message;

    if (hasError) {
      switch (errorCode) {
        case 0:
          messages.push(new MessageModel(MessageType.warning, this.translate.instant(`errors.233`)));
          break;
        default:
          messages.push(new MessageModel(MessageType.warning, errorMessage));
      }
    }

    return messages;
  }

  public checkAgreementsValidity(form: FormGroup, agreements: AgreementViewModel[]) {
    if (agreements?.length) {
      (form.get('agreements') as FormArray).controls.forEach((el, i) => {
        const agreement = agreements[i];
        agreement.checked = el.value;
        agreement.valid = agreement.checked || !agreement.required;

        if (!agreement.valid) {
          el.setErrors({ required: true });
        }
      });
    }
  }

  public onAgreementClick(form: FormGroup, agreement: AgreementViewModel, index: number) {
    agreement.checked = !agreement.checked;
    agreement.valid = agreement.checked;

    if (!agreement.checked) {
      (form.get('agreements') as FormArray).at(index).setValue(null);
    }
  }

  public prepareAgreements(formData, form: FormGroup, agreements: AgreementViewModel[]): void {
    if (!agreements) {
      return;
    }

    const formAgreements = (form.get('agreements') as FormArray)?.value;
    if (!formAgreements) {
      return;
    }

    formData.agreements = formAgreements
      .map((item, i) => agreements[i])
      .filter((item) => item.checked === true)
      .map((item) => item.id);

    for (const agreement of agreements) {
      const shouldBeAdded = agreement.required === true && (formData.agreements as Array<string>).indexOf(agreement.id) < 0;
      if (shouldBeAdded) {
        (formData.agreements as Array<string>).push(agreement.id);
      }
    }
  }
}
